export default __webpack_public_path__ + "static/IMG_1254-6190ead374814b50a1812173dfe8239c.jpg";